import React from 'react';
import PrematchContext from '../../contexts/PrematchContext';
import SelectionContext from '../../contexts/SelectionContext';
import { iconSportCssClass } from '../../data/utils';
import SelectionCountry from './SelectionCountry';

function SportSelectionHeader(props) {
    const selectionContext = React.useContext(SelectionContext);
    const prematchContext = React.useContext(PrematchContext);

    const currentFilter = prematchContext.temporalFilter;
    const countries = props.countrySelection == null ? props.categories : [props.categoryById[props.countrySelection]];
    const icoSport = iconSportCssClass(props.id, props.iconClass);

    function handleClick() {
        const tournamentsIds = [];
        countries.filter(c => c.filters[currentFilter] !== undefined).forEach(c => {
            c.tournaments.filter(t => t.filters[currentFilter] !== undefined).forEach(t => tournamentsIds.push(t.uniqueId));
        });
    
        let selectedTournaments = selectionContext.tournaments;
        const newSelectedTournaments = tournamentsIds.filter(t => selectedTournaments.indexOf(t) === -1);

        if (newSelectedTournaments.length > 0 && newSelectedTournaments.length <= tournamentsIds.length) {
            selectedTournaments.push(...tournamentsIds);
            selectionContext.setTournaments(selectedTournaments);
        } else {
            selectedTournaments = selectionContext.tournaments.filter(t => tournamentsIds.indexOf(t) === -1);
            selectionContext.setTournaments(selectedTournaments);
        }
    }

    return (
        <>
            <div className="w-100 maiuscolo grassetto nero titolo-sport-sel pointer" onClick={handleClick}>
                <div className={`img-fluid icona-sport-sel margine-dx ico-sport ${icoSport}`}></div>
                <h2 className="no-margin grassetto">{props.descrizione}</h2>
                {props.isLive &&
                    <span className="live-badge ml-1"></span>
                }
            </div>
            <div className="w-100 selezione-sport-box">
                {countries.filter(c => c.filters[currentFilter] !== undefined).map(c => {
                    return (
                        <SelectionCountry key={c.id} {...c} />
                    );
                })}
            </div>
        </>
    );
}

export default SportSelectionHeader;